module.exports = __webpack_public_path__ + "img/visa.4c85a6bd.png";